<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/WoA3cD/tc-custom/9781464207655.jpg?1730612299207" alt="This image is the cover for the book Ruddy Gore, Miss Fisher's Murder Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Ruddy Gore, Miss Fisher's Murder Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <p><b>From the author of the bestselling Phryne Fisher Series comes Ruddy Gore, the next historical mystery featuring the unstoppable, elegant amateur sleuth. Can Miss Fisher use her theater ties to take care of a phantasm haunting a Gilbert and Sullivan show?</b></p><p>"The appeal of this story is the glimpse it provides into the 1920s theater world and the opportunity it affords to observe Phryne and Lin Chung's romance from its inception."—<i>Booklist</i></p>Perfect for Fans of Rhys Bowen and Jacqueline WinspearInspired the Netflix show Miss Fisher's Murder MysteriesMovie Miss Fisher and the Crypt of Tears Currently Streaming on Acorn TVOne of the top-selling, best murder mystery books of 2018<p>Running late to the Hinkler gala performance of Gilbert and Sullivan's Ruddigore, Phryne Fisher meets some thugs in a dark alley and handles them convincingly before they can ruin her silver dress. Phryne then finds that she has rescued the handsome Lin Chung and his grandmother and is briefly mistaken for a deity.</p><p>Denying divinity but accepting cognac, she later continues safely to the theatre. But it seems the lead is dressed for death, as the performance is interrupted by a most bizarre death onstage. What links can Phryne possibly find between the ridiculously entertaining plot of Ruddigore, the Chinese community of Little Bourke Street, and the actors treading the boards of His Majesty's Theatre?</p><p>Drawn backstage and onstage, Phryne must solve an old murder, find a new murderer and of course, banish the theatre's ghost—who seems likely to kill again.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kerry Greenwood
      </h2>
      
      <p class="authorDescription body article"><P>Kerry Greenwood was born in the Melbourne suburb of Footscray and after wandering far and wide, she returned to live there. She has degrees in English and Law from Melbourne University and was admitted to the legal profession on the 1st April 1982, a day which she finds both soothing and significant. Kerry has written three series, a number of plays, including The Troubadours with Stephen D’Arcy, is an award-winning children’s writer and has edited and contributed to several anthologies. The Phryne Fisher series (pronounced Fry-knee, to rhyme with briny) began in 1989 with Cocaine Blues which was a great success. Kerry has written twenty books in this series with no sign yet of Miss Fisher hanging up her pearl-handled pistol. Kerry says that as long as people want to read them, she can keep writing them. In 2003 Kerry won the Lifetime Achievement Award from the Australian Association.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Poisoned Pen Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5d10bad7